'use client';

import dynamic from 'next/dynamic';
import { useInView } from 'react-intersection-observer';

export interface SavingsV2Props {
  vin: string;
  isGas: boolean;
  condition: string;
  knownInventory: boolean;
  bodyType: string;
  showIncentivesAndRebates?: boolean;
}

const SavingsToolV2 = dynamic(
  () => import('@/components/template/SavingsToolV2/SavingsToolV2'),
  {
    ssr: false,
  }
);
const SavingsToolV2NoRebates = dynamic(
  () => import('@/components/template/SavingsToolV2/SavingsToolV2NoRebates'),
  {
    ssr: false,
  }
);

export const IframesSavingsV2Template = (props: SavingsV2Props) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <div ref={ref}>
      {inView &&
        (props.showIncentivesAndRebates ? (
          <SavingsToolV2 {...props} />
        ) : (
          <SavingsToolV2NoRebates {...props} />
        ))}
    </div>
  );
};
